import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { SESSION_LOGS_COL } from "./sessionLogApi";

function sortByDateDesc(logs) {
  return [...logs].sort((a, b) => {
    const aMs = a.sessionStart?.toMillis?.() ?? a.sessionStart?.seconds * 1000 ?? 0;
    const bMs = b.sessionStart?.toMillis?.() ?? b.sessionStart?.seconds * 1000 ?? 0;
    return bMs - aMs;
  });
}

export async function fetchRecentStudentSessionLogs(studentId, maxCount = 15) {
  if (!studentId) return [];
  const q = query(
    collection(db, SESSION_LOGS_COL),
    where("studentId", "==", studentId),
    limit(60)
  );
  const snap = await getDocs(q);
  const logs = snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .filter((log) => !log.isDraft);
  return sortByDateDesc(logs).slice(0, maxCount);
}

export async function fetchPreviousSessionLog(studentId, beforeSessionId) {
  if (!studentId) return null;
  const q = query(
    collection(db, SESSION_LOGS_COL),
    where("studentId", "==", studentId),
    limit(60)
  );
  const snap = await getDocs(q);
  const logs = snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .filter((log) => !log.isDraft && log.id !== beforeSessionId);
  const sorted = sortByDateDesc(logs);
  return sorted[0] || null;
}

export async function fetchStudentProfile(studentId) {
  if (!studentId) return null;
  try {
    const snap = await getDoc(doc(db, "students", studentId));
    if (!snap.exists()) return null;
    return { id: snap.id, ...snap.data() };
  } catch {
    return null;
  }
}

// NOTE: Curriculum browsing for the Materials step now uses the unified
// `curriculum_libraries` model via CurriculumBrowserModal (which calls
// curriculumLibrariesService / curriculumService directly). The old per-type
// readers that hit the legacy collections were removed with the old picker.
